import {useCallback} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'
import {useDispatch} from 'react-redux'

import routes from 'routes/pathConfig'
import {clearTermsConditionState} from 'redux/slices/termsCondition'
import {closeModal} from 'redux/slices/partnerInfo'

import useAuthToken from '../persisted/useAuthToken'

export default function useOnUnauthorized() {
  const dispatch = useDispatch()
  const {t} = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const {setAuthToken} = useAuthToken()

  return useCallback(
    error => {
      setAuthToken(undefined)
      queryClient.clear()
      dispatch(clearTermsConditionState())
      dispatch(closeModal())

      if (error) {
        navigate(routes.login.path, {
          state: {
            from: location,
            message: t('login.errors.logoutMessage', {reason: error.toString()}),
          },
          replace: true,
        })
      } else {
        navigate(routes.login.path, {replace: true})
      }
    },
    [setAuthToken, queryClient, dispatch, navigate, location, t],
  )
}
